var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-radio',_vm._b({style:(_vm.style)},'v-radio',_vm.radioAttrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }